class HeightObserver extends HTMLElement {
  connectedCallback() {
    const variableName = this.getAttribute('variable-name') || '--content-height';
    const setOnBody = this.getAttribute('set-on-body') === 'true';
    const targetEl = setOnBody ? document.body : this;

    this.observer = new ResizeObserver(() => {
      if (!targetEl) return;
      const computedStyle = window.getComputedStyle(this);
      const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
      const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
      const contentHeight = this.clientHeight - paddingTop - paddingBottom;

      targetEl.style.setProperty(variableName, `${contentHeight}px`);
      this.style.opacity = '1';
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('height-observer')) {
  customElements.define('height-observer', HeightObserver);
}
